import { Box } from "@mui/material";

export const ProgressBar = ({ progress }) => {
  return (
    <Box
      sx={{
        height: "8px",
        borderRadius: "4px",
        background: "#67676733",
        width: "100%",
      }}
    >
      <Box
        sx={{
          width: `${progress}%`,
          height: "8px",
          borderRadius: "4px",
          background: "#6B8E76",
        }}
      />
    </Box>
  );
};
